import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import CustomhtmlForFeature from 'utils/CustomDefault';
import htmlForFeature from 'utils/htmlForFeature';

export const HIGH_INJURY_NETWORK_LAYER_ID = 'highInjuryNetworkLayer';

const layerConfig = {
  title: 'High Injury Network',
};

function HighInjuryNetworkLayer() {
  const dispatch = useDispatch();
  const { highInjuryNetworkLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, highInjuryNetworkLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (highInjuryNetworkLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: HIGH_INJURY_NETWORK_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: highInjuryNetworkLayer.visible,
      opacity: highInjuryNetworkLayer.opacity,

      getLineColor: [179, 0, 0],
      lineWidthMinPixels: 3,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: HIGH_INJURY_NETWORK_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
            }),
          };
        }
      }
    });
  }
}

export default HighInjuryNetworkLayer;
